/**
 * This file is part of Gutenberg Carousel Block.
 *
 * Gutenberg Carousel Block is free software: you can redistribute it and/or modify it
 * under the terms of the GNU General Public License as published by the Free
 * Software Foundation, either version 2 of the License, or any later version.
 *
 * Gutenberg Carousel Block is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
 * or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License for
 * more details.
 *
 * You should have received a copy of the GNU General Public License along with
 * Gutenberg Carousel Block.  If not, see <https://www.gnu.org/licenses/>.
 */
import 'slick-carousel'
import 'slick-carousel/slick/slick.scss'

jQuery( function () {
	jQuery( '.wp-block-tandem-post-carousel' ).slick();
} );

